export default __webpack_public_path__ + "static/media/ticket_en.42791483.png";